<div class="col-sm-12 my-3 my-md-5">
    <div class="row">
        <div class="col-sm-6">
            <h2>Booked Scan Details</h2>
        </div>
        <div class="col-sm-6">
            <a routerLink="/scan-booked-list" class="ml-2 btn btn-success pull-right">
                <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </a>
        </div>
    </div>
    <div class="col-sm-12 text-center"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner spinloader"></i></div>
    <mat-tab-group mat-align-tabs="start">
        <mat-tab label="Basic Info">
            <div class="card">
                <form [formGroup]="ScanForm" (submit)="updateScanForm()">
                    <div class="col-sm-12 p-3">
                        <div class="col-sm-8 border-right">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Patient Name *</label>
                                        <input type="text" formControlName="patient_name" class="form-control readOnly" readonly />
                                        <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                                            <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                                        </div>
                                        
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Patient Mobile *</label>
                                        <input type="text" formControlName="mobile" class="form-control readOnly" readonly />
                                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                            <div *ngIf="f.mobile.errors.required">Patient Number is required</div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Patient Age *</label>
                                        <input type="number" formControlName="patient_age" class="form-control" />
                                        <div *ngIf="submitted && f.patient_age.errors" class="invalid-feedback">
                                            <div *ngIf="f.patient_age.errors.required">Patient Age is required</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Gender *</label>
                                        <mat-select placeholder="Gender" formControlName="gender">
                                            <mat-option value="Male">Male</mat-option>
                                            <mat-option value="Female">Female</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                                            <div *ngIf="f.gender.errors.required">Gender is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Patient Email*</label>
                                        <input type="email" formControlName="email" class="form-control" />
                                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                            <div *ngIf="f.email.errors.required">Email is required</div>
                                            <div *ngIf="!f.email.valid && f.email.value">Email format is Invalid</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Treatment *</label>
                                        <mat-select placeholder="Select Treatment" formControlName="treatment_id" (click)="setSearchValue('treatment')">
                                            <input class="mySearchInput"
                                            #treatmentSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off"
                                            placeholder="Search"
                                            id="treatmentSearch">
                                            <mat-option value="">Select Treatment</mat-option>
                                            <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                                            <div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                                        </div>
                                        <div *ngIf="f.treatment_id.value=='37' && invalidTreatment" class="invalid-feedback">
                                            <div>Please select valid treatment</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Select Status*</label>
                                        <mat-select placeholder="Select Status" formControlName="status" >
                                            <mat-option value="">Select Status</mat-option>
                                            <mat-option [value]="0">Active</mat-option>
                                            <mat-option [value]="1">Completed</mat-option>
                                            <mat-option [value]="3">Cancel</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                            <div *ngIf="f.status.errors.required">Status is required</div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-sm-6">
                                        <label class="form-label">Select BD *</label>
                                        <mat-select placeholder="Select BD" formControlName="user_id" (click)="setSearchValue('lead_owner')">
                                            <input class="mySearchInput"
                                            #ownerSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'lead_owner')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off"
                                            placeholder="Search"
                                            id="ownerSearch">
                                            <mat-option value="">Select BD</mat-option>
                                            <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                                            <div *ngIf="f.user_id.errors.required">BD is required</div>
                                        </div>
                                        <div *ngIf="f.user_id.value=='21' && invalidBd" class="invalid-feedback">
                                            <div>Please select valid BD</div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Select Machine*</label>
                                        <mat-select placeholder="Select Machine" formControlName="scan_machine">
                                            <mat-option [value]="machine.id" *ngFor="let machine of machineList">{{machine.name}}</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.scan_machine.errors" class="invalid-feedback">
                                            <div *ngIf="f.scan_machine.errors.required">Machine is required</div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-sm-6">
                                        <label class="form-label">Select Scan Pro </label>
                                        <mat-select placeholder="Select Scan Pro" formControlName="scan_pro_user_id">
                                            <mat-option value="">Select Scan Pro</mat-option>
                                            <mat-option [value]="pro.id" *ngFor="let pro of scanProUser">{{pro.name}}</mat-option>
                                        </mat-select>
                                        <!-- <div *ngIf="submitted && f.scan_pro_user_id.errors" class="invalid-feedback">
                                            <div *ngIf="f.scan_pro_user_id.errors.required">Scan Pro is required</div>
                                        </div> -->
                                        <!-- <div *ngIf="f.scan_pro_user_id.value=='21' && invalidBd" class="invalid-feedback">
                                            <div>Please select valid Scan Pro</div>
                                        </div> -->
                                    </div>

                                </div>
                            </div> 
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <label class="form-label">Appointment Type*</label>
                                        <mat-select placeholder="Select Appointment Type" formControlName="appointment_type">
                                            <mat-option [value]="1">New Scan</mat-option>
                                            <mat-option  *ngIf="scanId" [value]="2">Re-Scan</mat-option>
                                            <mat-option  [value]="3">Trust Align</mat-option>
                                        </mat-select>
                                        
                                    </div>
                                
                                    <div class="col-sm-4">
                                        <label class="form-label">Appointment Date *</label>
                                        <!-- <input type="datetime-local" formControlName="appointment_datetime" class="form-control" (change)="getTimeslotsChangeBox()" (keyup)="getTimeslotsChangeBox()"/>
                                        <div *ngIf="submitted && f.appointment_datetime.errors" class="invalid-feedback">
                                            <div *ngIf="f.appointment_datetime.errors.required">Appointment Date & Time is required</div>
                                        </div> -->
                                        <mat-form-field appearance="fill">
                                            <mat-label>Choose a date</mat-label>
                                            <input  matInput readonly formControlName="appointment_datetime" [matDatepicker]="appt_picker" (dateChange)="getTimeslotsChangeBox()" (keyup)="getTimeslotsChangeBox()">
                                            <mat-datepicker-toggle matSuffix [for]="appt_picker"></mat-datepicker-toggle>
                                            <mat-datepicker #appt_picker></mat-datepicker>
                                        </mat-form-field>
                                        <div *ngIf="submitted && f.appointment_datetime.errors" class="invalid-feedback">
                                            <div *ngIf="f.appointment_datetime.errors.required">Appointment Date is required</div>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <label class="form-label">Select Timeslot*</label>
                                        <mat-select placeholder="Select Timeslot" formControlName="time_slots">
                                            <mat-option value="">Select Timeslot</mat-option>
                                            <mat-option [value]="tslist.split('-')[0]" *ngFor="let tslist of timeslotsList">{{tslist}}</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.time_slots.errors" class="invalid-feedback">
                                            <div *ngIf="f.time_slots.errors.required">Timeslot is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Select Visit Type*</label>
                                        <mat-select placeholder="Select Visit Type" formControlName="visit_type" (selectionChange)="showAddressBox($event)">
                                            <mat-option [value]="1">Home</mat-option>
                                            <mat-option [value]="2">Clinic</mat-option>
                                            <mat-option [value]="3">Glamyo</mat-option>
                                        </mat-select>
                                        <div *ngIf="submitted && f.visit_type.errors" class="invalid-feedback">
                                            <div *ngIf="f.visit_type.errors.required">Visit Type is required</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group" *ngIf="ScanForm.controls['visit_type'].value==1 || ScanForm.controls['visit_type'].value==3">
                                            <label class="form-label">Scan Address*</label>
                                            <textarea class="form-control" formControlName="scan_address"></textarea>
                                        
                                            <div *ngIf="submitted && f.scan_address.errors" class="invalid-feedback">
                                                <div *ngIf="f.scan_address.errors.required">Scan Address is required</div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6" *ngIf="ScanForm.controls['visit_type'].value==2">
                                                <label class="form-label">Select Clinic Type*</label>
                                                <mat-select placeholder="Select Clinic Type" formControlName="clinic_type" (selectionChange)="getHospitalOrClinic($event.value)">
                                                    <mat-option [value]="1">All</mat-option>
                                                    <mat-option [value]="2">Dental Clinic</mat-option>
                                                </mat-select>
                                                <div *ngIf="submitted && f.clinic_type.errors" class="invalid-feedback">
                                                    <div *ngIf="f.clinic_type.errors.required">Clinic Type is required</div>
                                                </div>
                                            </div>
    
    
                                            <div class="col-sm-6" *ngIf="ScanForm.controls['visit_type'].value==2">
                                                <label class="form-label" >Select Clinic *</label>
                                                <mat-select placeholder="Select Clinic" [disabled]="type_Clinic" formControlName="hospital_id" (click)="setSearchValue('hospital')" (selectionChange)="getHospitalAddress()">
                                                    <input class="mySearchInput"
                                                    #hospitalSearch focused="'true'" type="text"
                                                    (keyup)="searchOnSelect($event.target.value, 'hospital')"
                                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                                    placeholder="Search"
                                                    id="hospitalSearch">
                                                    <mat-option value="">Select Hospital</mat-option>
                                                    <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                                                </mat-select>
                                                <div *ngIf="submitted && f.hospital_id.errors" class="invalid-feedback">
                                                    <div *ngIf="f.hospital_id.errors.required">Hospital is required</div>
                                                </div>
                                                <div [innerHtml]="clinic_address"></div>
                                            </div>

                                        </div>
                                        
                                      
                                    </div>
                                </div>
                            </div> 
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Reference Type</label>
                                        <mat-select placeholder="Select Reference Type" formControlName="reference_type">
                                            <mat-option value="Glamyo">Glamyo</mat-option>
                                            <mat-option value="BD Scan">BD Scan</mat-option>
                                            <mat-option value="Other">Other</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="form-label">Google Location</label>
                                            <textarea class="form-control" formControlName="google_location"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="col-sm-12" *ngIf="myrole != '11' && myrole != '21' && myrole != '8' && myrole != '24'">
                            <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>  Update</button>
                        </div>
                        
                    </div>           
                </form>
            </div>
        </mat-tab>
        <mat-tab label="Payment & Documents Info" *ngIf="scanId">
            <div class="card col-sm-12">
                <div class="row" style="padding-left: 15px; padding-right: 15px;">
                    <div class="col-sm-9 pt-4 border-right">
                        <form [formGroup]="ScanUpdateForm" (submit)="addUpdateScanPayment()"> 
                            <div class="form-group pt-4">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Scan Status*</label>
                                        <mat-select placeholder="Select" formControlName="scan_status" (selectionChange)="addRemoveValidator('1',$event.value)">
                                            <mat-option [value]="1">Yes</mat-option>
                                            <mat-option [value]="2">No</mat-option>
                                        </mat-select>
                                        <div *ngIf="submittedpayment && g.scan_status.errors" class="invalid-feedback">
                                            <div *ngIf="g.scan_status.errors.required">Scan Status is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div class="form-group" *ngIf="ScanUpdateForm.controls['scan_status'].value==2">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label class="form-label">Reason*</label>
                                        <textarea rows="4" style="width:50%;" formControlName="no_scan_reason"></textarea>
                                        <div *ngIf="submittedpayment && g.no_scan_reason.errors" class="invalid-feedback">
                                            <div *ngIf="g.no_scan_reason.errors.required">Reason is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">RCA*</label>
                                        <mat-select placeholder="Select" formControlName="rca" (selectionChange)="getSubRCA($event.value)">
                                            <mat-option [value]="1">Budget Problem</mat-option>
                                            <mat-option [value]="2">Want Reschedule</mat-option>
                                            <mat-option [value]="3">Cancel Appointment</mat-option>
                                            <mat-option [value]="4">Scanner Movement Delay</mat-option>
                                            <mat-option [value]="5">Not Answer</mat-option>
                                        </mat-select>
                                        <div *ngIf="submittedpayment && g.rca.errors" class="invalid-feedback">
                                            <div *ngIf="g.rca.errors.required">RCA is required</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Sub RCA*</label>
                                        <mat-select placeholder="Select" formControlName="sub_rca" >
                                            <mat-option [value]="srca.id" *ngFor="let srca of sub_rca_arr">{{srca.name}}</mat-option>
                                        </mat-select>
                                        <div *ngIf="submittedpayment && g.sub_rca.errors" class="invalid-feedback">
                                            <div *ngIf="g.sub_rca.errors.required">Sub RCA is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            <div class="form-group" *ngIf="ScanUpdateForm.controls['scan_status'].value==1">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Scan Done Date*</label>
                                        <mat-form-field appearance="fill">
                                            <mat-label>Choose a date</mat-label>
                                            <input  matInput readonly formControlName="scan_done_date" [matDatepicker]="picker">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <div *ngIf="submittedpayment && g.scan_done_date.errors" class="invalid-feedback">
                                            <div *ngIf="g.scan_done_date.errors.required">Scan Done Date is required</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Document Upload Date</label>
                                        <mat-form-field appearance="fill">
                                            <mat-label>Choose a date</mat-label>
                                            <input  matInput readonly formControlName="document_upload_date" [matDatepicker]="du_picker">
                                            <mat-datepicker-toggle matSuffix [for]="du_picker"></mat-datepicker-toggle>
                                            <mat-datepicker #du_picker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label">Dental Lab</label>
                                        <mat-select placeholder="Select Dental Lab" formControlName="orthodontist_user_id" (click)="setSearchValue('orthodontist_user')" multiple>
                                            <input class="mySearchInput"
                                            #orthodontistSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'orthodontist_user')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off"
                                            placeholder="Search"
                                            id="orthodontistSearch">
                                            <mat-option value="{{orthoUser.id}}" *ngFor="let orthoUser of ortho_user">{{orthoUser.name}}</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label">Scan Google Form Link</label>
                                        <input type="text" placeholder="Google Form Link" formControlName="google_form_link" class="form-control" />
                                        <label *ngIf="google_link_share_on  && (myrole=='1' || (myrole=='3' && isCMAccess=='1'))" class="form-label col-md-12 text-primary">Google Form Link Sent On: <span>{{google_link_share_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></label> 
                                    </div>
                                    <div class="col-sm-2" *ngIf="google_link_share_on && (myrole=='1' || (myrole=='3' && isCMAccess=='1'))">
                                        <label class="form-label">&nbsp;</label>
                                        <button type="button" [disabled]="mail_sending" class="btn btn-success" (click)="share_google_links(scanId)"><span *ngIf="mail_sending"><i class="fa fa-spin fa-spinner"></i></span> Share Link <i class="fa fa-share"></i></button>
                                    </div>
                                </div>
                            </div> 
                            <div class="form-group" *ngIf="ScanUpdateForm.controls['scan_status'].value==1">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Patient Category*</label>
                                        <mat-select placeholder="Select Patient Category" formControlName="patient_category">
                                            <mat-option value="HIG">HIG</mat-option>
                                            <mat-option value="MIG">MIG</mat-option>
                                            <mat-option value="LIG">LIG</mat-option>
                                        </mat-select>
                                        <div *ngIf="submittedpayment && g.patient_category.errors" class="invalid-feedback">
                                            <div *ngIf="g.patient_category.errors.required">Patient Category is required</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Offer Given (In Amount)*</label>
                                        <input type="text" formControlName="offer_given" class="form-control"/>
                                        <div *ngIf="submittedpayment && g.offer_given.errors" class="invalid-feedback">
                                            <div *ngIf="g.offer_given.errors.required">Offer Given (In Amount) is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>         
                            <div class="form-group" *ngIf="ScanUpdateForm.controls['scan_status'].value==1">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Payment*</label>
                                        <mat-select placeholder="Select Payment" formControlName="payment_status" (selectionChange)="addRemoveValidator('2',$event.value)">
                                            <mat-option [value]="1">Yes</mat-option>
                                            <mat-option [value]="2">No</mat-option>
                                        </mat-select>
                                        <div *ngIf="submittedpayment && g.payment_status.errors" class="invalid-feedback">
                                            <div *ngIf="g.payment_status.errors.required">Payment Status is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="ScanUpdateForm.controls['payment_status'].value==2">
                                <div class="form-group" >
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label class="form-label">Reason</label>
                                            <textarea rows="4" style="width: 50%;" formControlName="no_payment_reason"></textarea>
                                            <div *ngIf="submittedpayment && g.no_payment_reason.errors" class="invalid-feedback">
                                                <div *ngIf="g.no_payment_reason.errors.required">Reason is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            
                            <div class="form-group" *ngIf="ScanUpdateForm.controls['payment_status'].value==1">
                                <div class="row ">
                                    <div class="col-sm-6">
                                        <label class="form-label">Convert Type</label>
                                        <mat-select placeholder="Select Convert Type" formControlName="convert_type">
                                            <mat-option value="PAS">PAS</mat-option>
                                            <mat-option value="Inside">Inside</mat-option>
                                            <mat-option value="Backend">Backend</mat-option>
                                            <mat-option value="Trustalign">Trustalign</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Any other Dental</label>
                                        <mat-select placeholder="Select Any other Dental" formControlName="any_other_dental" multiple>
                                            <mat-option value="Extraction">Extraction</mat-option>
                                            <mat-option value="Scaling">Scaling</mat-option>
                                            <mat-option value="Bridge">Bridge</mat-option>
                                            <mat-option value="Filling">Filling</mat-option>
                                            <mat-option value="Frenectony">Frenectony</mat-option>
                                            <mat-option value="Cavity">Cavity</mat-option>
                                            <mat-option value="Braces">Braces</mat-option>
                                            <mat-option value="RCT">RCT</mat-option>
                                            <mat-option value="Implant">Implant</mat-option>
                                            <mat-option value="Crown">Crown</mat-option>
                                            <mat-option value="Bleaching">Bleaching</mat-option>
                                            <mat-option value="Capping">Capping</mat-option>
                                            <mat-option value="Retainer Removal">Retainer Removal</mat-option>
                                            <mat-option value="RPD">RPD</mat-option>
                                            <mat-option value="PFM">PFM</mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-sm-6">
                                        <label class="form-label">Payment Date (Date & Time)</label>
                                        <input type="datetime-local" formControlName="payment_datetime" class="form-control" />
                                        <div *ngIf="submittedpayment && g.payment_datetime.errors" class="invalid-feedback">
                                            <div *ngIf="g.payment_datetime.errors.required">Payment Date is required</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Transaction ID</label>
                                        <input type="text" formControlName="transaction_id" class="form-control"/>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-sm-6">
                                        <label class="form-label">Package Price</label>
                                        <input type="number" formControlName="package_price" class="form-control" (keyup)="calculate_gst_with_package_price()"/>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Discount Price</label>
                                        <input type="number" formControlName="discount_price" class="form-control" (keyup)="calculate_gst_with_package_price()"/>
                                    </div>
                                </div>


                                <div class="row mt-5">
                                    <div class="col-sm-3">
                                        <label class="form-label">Total Amount</label>
                                        <input type="number" formControlName="billed_amt" class="form-control readOnly" readOnly/>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="form-label">GST Amount</label>
                                        <input type="number" formControlName="gst_amount" class="form-control readOnly"  readonly/>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="form-label">Billed Amount</label>
                                        <input type="number" formControlName="after_gst_billed_amt" class="form-control readOnly" readonly/>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="form-label">Balance Amount</label>
                                        <input type="number" formControlName="balanced_amount" class="form-control readOnly" readonly/>
                                    </div>
                                    <div class="col-md-3 pt-1">
                                        <button *ngIf="myrole != '8' && myrole != '24'" type="button" (click)="addMoreReceivedAmount()" class="btn btn-primary pull-left"> Add Received Amount</button>
                                    </div>
                                    <!-- <div class="col-md-3 pt-1" *ngIf="myrole=='1'">
                                        <button type="button" (click)="openHistoryPopup()" class="btn btn-primary pull-left"> View Amount History</button>
                                    </div> -->
                                </div>


                                <div formArrayName="receivedAmtResources" style="display: contents;">
                                    <div class="row mt-3"  *ngFor="let quantity of receivedAmtResources().controls; let i=index" [formGroupName]="i">
                                        <div *ngIf="!quantity.value.scanPaymentId" class="col-md-12 text-danger"><b>Note**:(Only For Cash)</b> Without OTP OR If OTP Not Verified, Amount and payment mode will not save.</div>

                                        <div class="col-md-2">
                                            <label class="form-label">Received Amount</label>
                                            <input type="number" formControlName="received_amt" class="form-control text-left receive_amount" (keyup)="get_total_receive_amount()" [readonly]="quantity.value.scanPaymentId"/>
                                        </div>
                                        <div class="col-sm-3">
                                            <label class="form-label">Payment Mode</label>
                                            <mat-select placeholder="Select Payment" formControlName="payment_mode" [disabled]="quantity.value.scanPaymentId != ''" (selectionChange)="sendOTPforCash(i)">
                                                <mat-option [value]="1">Cash</mat-option>
                                                <mat-option [value]="2">Cheque</mat-option>
                                                <mat-option [value]="3">Razor Pay</mat-option>
                                                <mat-option [value]="4">EMI</mat-option>
                                                <mat-option [value]="5">Net Banking</mat-option>
                                                <mat-option [value]="6">Insurance</mat-option>
                                            </mat-select>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label">Payment Screenshot Link</label>
                                            <input type="text" formControlName="payment_screenshot_link" class="form-control text-left" [readonly]="quantity.value.scanPaymentId"/>
                                        </div>
                                        <div class="col-md-2" *ngIf="!quantity.value.scanPaymentId && showotpBox[i]">
                                            <label class="form-label">OTP</label>
                                            <input type="number" formControlName="payment_otp" class="form-control text-left receive_amount" (keyup)="show_submit_otp_button('1',i)"/>
                                        </div>
                                        <input type="hidden" formControlName="scanPaymentId" >
                                        <div class="col-md-1" *ngIf="!quantity.value.scanPaymentId">
                                            <label class="form-label">&nbsp;</label>
                                            <button *ngIf="!hideOtpButton[i]" type="button" class="btn btn-primary" (click)="sendOTPButton(i, $event)">Send OTP</button>
                                            <button *ngIf="showresenOtpButton[i]" type="button" class="btn btn-primary" (click)="sendOTPButton(i, $event)">Re Send OTP</button>
                                            <button *ngIf="showsubmitOtpButton[i]" type="button" class="btn btn-primary" (click)="submitOTPButton(i)">Submit OTP</button>
                                            <div *ngIf="showOtpVerified[i]">OTP Verified <i class="fa fa-check text-success" aria-hidden="true"></i></div>
                                        </div>
                                        <div class="col-md-1" *ngIf="((i > 0 && quantity.value.scanPaymentId) || (!quantity.value.scanPaymentId)) && myrole != '21' && myrole != '8' && myrole != '24'">
                                            <label class="form-label">&nbsp;</label>
                                            <button
                                                class="btn btn-danger"
                                                mwlConfirmationPopover
                                                [popoverTitle]="popoverTitle"
                                                [popoverMessage]="popoverMessage"
                                                [confirmText]="confirmText"
                                                [cancelText]="cancelText"
                                                [placement]="placement"
                                                (confirm)="removeQuantity(i, quantity.value.scanPaymentId)"
                                                (cancel)="cancelClicked = true"
                                                confirmButtonType="danger"
                                                cancelButtonType="outline-secondary"
                                                (click)="confirmClicked = false; cancelClicked = false"
                                                [appendToBody]="true">
                                            Remove
                                            </button>
                                        </div>
                                        <div class="col-md-2">
                                            
                                        </div>
                                    </div>
                                </div>




                            </div>
                            <div class="modal-footer pull-left">
                                <button *ngIf="myrole != '8' && myrole != '24'" [disabled]="loadingPayment" type="submit" class="btn btn-primary pull-left"> <i *ngIf="loadingPayment" class="fa fa-spin fa-spinner"></i> Save changes</button>
                            </div>
                        </form>      
                    </div>
                    <div class="col-sm-3 pt-4" *ngIf="scanId">
                        <div *ngIf="myrole == '1' || (myrole == '3' && isCMAccess == '1') || userId == '582' || userId == '695' || userId == '584' ">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <button type="button" [disabled]="payment_loading" (click)="validate_payment_recipt_type(1)" class="btn btn-success">
                                            <i class="fa fa-download" aria-hidden="true"></i> Download Receipt 
                                        </button>
                                    </div>
                                    <div class="col-md-6">
                                        <button type="button" [disabled]="payment_loading" (click)="validate_payment_recipt_type(2)" class="btn btn-primary">
                                            <span *ngIf="payment_email_loading" ><i class="fa fa-spin fa-spinner"></i>&nbsp; &nbsp;</span>
                                            <i class="fa fa-envelope"  aria-hidden="true"></i> 
                                            <span *ngIf="payment_email_loading"> Please Wait...</span> 
                                            <span *ngIf="!payment_email_loading"> Send Receipt </span>
                                        </button>
                                    </div>
                                    <div class="col-sm-12" *ngIf="payment_email_loading">
                                        <br>
                                        <b>***Note::</b> <span class="text-success">&nbsp; &nbsp;Please wait email sending is in process.</span>
                                    </div>
                                </div>
                            </div>
                            <hr>
                        </div> 

                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6" *ngIf="myrole != '8' && myrole != '24'">
                                    <label class="form-label">Select Documents Type</label>
                                    <mat-select placeholder="Select Documents Type" [(ngModel)]="doc_type" [ngModelOptions]="{standalone: true}">
                                        <mat-option [value]="1">Stl File</mat-option>
                                        <mat-option [value]="2">Photos</mat-option>
                                        <mat-option [value]="3">Consent form</mat-option>
                                        <mat-option [value]="6">Payment Receipt</mat-option>
                                    </mat-select>
                                </div>
                                
                                <div class="col-sm-6" *ngIf="myrole != '8' && myrole != '24'">
                                    <label class="form-label">Upload Document</label>
                                    <input type="file" class="form-control" [multiple]="true" (change)="selectFile($event)" [(ngModel)]="doc_file" [ngModelOptions]="{standalone: true}"/>
                                    <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                                </div>

                                <div class="col-md-12">
                                    <div class="list-group list-group-flush list-group-hoverable docList">
                                        <div *ngFor="let upload of allUploads">
                                            <div class="row showfileblock m-10 align-items-center" *ngIf='upload.upload_type==1 ||  upload.upload_type==2 || upload.upload_type==3 || (upload.upload_type==6)'>
                                                <div class="col">
                                                    <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>

                                                    <a *ngIf="myrole=='1' && !fileDeletingLoader" class="delete-file float-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                                    [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                                                    confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                                    [appendToBody]="true"><i class="fa fa-trash text-danger"></i></a>

                                                    <i *ngIf="fileDeletingLoader" class="fa fa-spin fa-spinner float-right text-danger"></i>

                                                    <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Stl File</span>
                                                    <span class="badge badge-info" *ngIf='upload.upload_type==2'>Photos</span>
                                                    <span class="badge badge-success" *ngIf='upload.upload_type==3'>Consent form</span>
                                                    <span class="badge badge-primary" *ngIf='upload.upload_type==6'>Payment Receipt</span>
                                                    
                                                    <small class="d-block text-muted  mt-n1">{{s3url+upload.filepath}}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Generate Plan" *ngIf="generate_plan_counter">
            <div class="card col-sm-12">
                <div class="row" style="padding-left: 15px; padding-right: 15px;">
                    <div class="col-sm-7 pt-4 border-right">
                        <form [formGroup]="ScanPlanForm" (submit)="addUpdatePlanDocs()">
                            <div class="form-group">
                                <label class="form-label">Plan Generate</label>
                                <mat-button-toggle-group aria-label="Plan Generate"  formControlName="plan_generate" >
                                    <mat-button-toggle value="1">Yes</mat-button-toggle>
                                    <mat-button-toggle value="2">No</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <!-- <div class="col-sm-5" *ngIf="ScanPlanForm.controls['plan_generate'].value==1">
                                <label class="form-label">Orthodontist User</label>
                                <mat-select placeholder="Select Orthodontist" formControlName="orthodontist_user_id" (click)="setSearchValue('orthodontist_user')">
                                    <input class="mySearchInput"
                                    #orthodontistSearch focused="'true'" type="text"
                                    (keyup)="searchOnSelect($event.target.value, 'orthodontist_user')"
                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                    placeholder="Search"
                                    id="orthodontistSearch">
                                    <mat-option>Select Orthodontist</mat-option>
                                    <mat-option [value]="orthoUser.id" *ngFor="let orthoUser of ortho_user">{{orthoUser.name}}</mat-option>
                                </mat-select>
                            </div> -->
                            <div class="form-group" *ngIf="ScanPlanForm.controls['plan_generate'].value==2">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label class="form-label">Reason</label>
                                        <textarea rows="4" style="width: 50%;" formControlName="plan_no_reason"></textarea>
                                    </div>
                                </div>
                            </div>
                            
                        
                            <div class="col-sm-12 pt-4" *ngIf="ScanPlanForm.controls['plan_generate'].value==1">

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="pre_treatment_procedure">
                                            <span class="custom-control-label">Pre-treatment Procedure</span>
                                        </label>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" formControlName="pre_delivery_procedure">
                                            <span class="custom-control-label">Pre-Delivery Procedure</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6"  *ngIf="ScanPlanForm.controls['pre_treatment_procedure'].value==true">
                                        <label class="form-label">Pre-treatment Procedure Remarks</label>
                                        <textarea class="form-control" rows="4" formControlName="pre_treatment_procedure_remarks"></textarea>
                                    </div>
                                    <div class="col-sm-6" *ngIf="ScanPlanForm.controls['pre_delivery_procedure'].value==true">
                                        <label class="form-label">Pre-Delivery Procedure Remarks</label>
                                        <textarea class="form-control" rows="4" formControlName="pre_delivery_procedure_remarks"></textarea>
                                    </div>
                                </div>
                            </div>


                            <div class="form-group pt-4">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <label class="form-label">Select Share Type</label>
                                        <mat-select placeholder="Select Share Type" formControlName="plan_share_type">
                                            <mat-option [value]="1">Type 1</mat-option>
                                            <mat-option [value]="2">Type 2</mat-option>
                                            <mat-option [value]="3">Type 3</mat-option>
                                            <mat-option [value]="4">Type 4</mat-option>
                                            <mat-option [value]="5">Type 5</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-4">
                                        <label class="form-label">Select Documents Type</label>
                                        <mat-select placeholder="Select Documents Type" formControlName="plan_doc_type">
                                            <mat-option [value]="4">Patient plan video</mat-option>
                                            <mat-option [value]="5">Patient plan pdf</mat-option>
                                        </mat-select>
                                    </div>
                                    
                                    <div class="col-sm-4">
                                        <label class="form-label">Upload Document</label>
                                        <input #planUploadFile type="file" class="form-control" (change)="selectPlanFile($event)" />
                                    </div>
                                    
                                    <div class="col-md-12 m-10 pr-35">
                                        <div class="list-group list-group-flush list-group-hoverable docList">
                                            <div *ngFor="let upload of allUploads">

                                                <div class="row showfileblock align-items-center" *ngIf="upload.upload_type==4||upload.upload_type==5">
                                                    <div class="col text-truncate">
                                                        <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">
                                                            <span class="ft-10" *ngIf="upload.plan_share_type"> (Type {{upload.plan_share_type}})</span> View File</a> 

                                                        <a *ngIf="myrole=='1' && !fileDeletingLoader" class="delete-file float-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                                        [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                                                        confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                                        [appendToBody]="true"><i class="fa fa-trash text-danger"></i></a>

                                                        <i *ngIf="fileDeletingLoader" class="fa fa-spin fa-spinner float-right text-danger"></i>

                                                        <span class="badge badge-danger" *ngIf='upload.upload_type==4'>Patient plan video</span>
                                                        <span class="badge badge-info" *ngIf='upload.upload_type==5'>Patient plan pdf</span>

                                                        
                                                        <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <label class="form-label">Aligner Duration</label>
                                            <input type="number" formControlName="aligners_duration" class="form-control" />
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="form-label">Upper Aligner</label>
                                            <input type="number" formControlName="upper_aligners" class="form-control"/>
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="form-label">Lower Aligner</label>
                                            <input type="number" formControlName="lower_aligners" class="form-control"/>
                                        </div>
                                    </div>
    
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label class="form-label">Other Information about the treatment</label>
                                            <textarea class="form-control" rows="5" formControlName="other_information"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!----------Lab Details-------------->
                            <div class="form-group">
                                <div class="row">
                                    <div class="text-title-center pt-4"><span>Snazzy Dental Lab</span></div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Upper Aligner</label>
                                        <input type="number" formControlName="upper_aligners_725" class="form-control"/>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Lower Aligner</label>
                                        <input type="number" formControlName="lower_aligners_725" class="form-control"/>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-sm-6">
                                        <label class="form-label">Other Information about the treatment</label>
                                        <textarea class="form-control" rows="5" formControlName="other_information_725"></textarea>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Pre-treatment Procedure Remarks</label>
                                        <textarea class="form-control" rows="4" formControlName="pre_treatment_procedure_remarks_725"></textarea>
                                    </div>
                                </div>
                            </div>
                            

                            <div class="form-group">
                                <div class="row">
                                    <div class="text-title-center pt-4"><span>ODS Dental Lab</span></div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Upper Aligner</label>
                                        <input type="number" formControlName="upper_aligners_726" class="form-control"/>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Lower Aligner</label>
                                        <input type="number" formControlName="lower_aligners_726" class="form-control"/>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-sm-6">
                                        <label class="form-label">Other Information about the treatment</label>
                                        <textarea class="form-control" rows="5" formControlName="other_information_726"></textarea>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="form-label">Pre-treatment Procedure Remarks</label>
                                        <textarea class="form-control" rows="4" formControlName="pre_treatment_procedure_remarks_726"></textarea>
                                    </div>
                                </div>
                            </div>
                            <!----------Lab Details-------------->
                           
                            
                        </div>
                        <div class="modal-footer pull-left savebtn" *ngIf="myrole != '11' && myrole != '21' && myrole != '8' && myrole != '24'">
                            <button type="submit" [disabled]="planuploading" class="btn btn-primary pull-left"> <span *ngIf="planuploading"><i class="fa fa-spin fa-spinner"></i></span> Save</button>
                        </div>
                    </form>
                    </div>
                    <div class="col-sm-5 pt-4">
                        
                        <!---------For Patient Share------------>
                        <div *ngIf="aligner_duration_counter > 0 && mail_send_btn_plan_generate==1">
                            <div class="row" *ngIf="production_status_tab">
                                <label class="form-label col-md-12 text-primary">Last Share With Patient On: <span>{{patient_share_on*1000|date:'d MMM, yyyy hh:mm aa'}}</span></label> 
                            </div>

                            <div class="row" *ngIf="myrole != '21' && myrole != '8' && myrole != '24'">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <mat-select [(ngModel)]="share_type_select"  placeholder="Select Share Type">
                                            <mat-option [value]="stype.plan_share_type" *ngFor="let stype of share_type_array">Type {{stype.plan_share_type}}</mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="col-md-5" >
                                    <button type="button" [disabled]="mail_sending" class="btn btn-success" (click)="plan_share_with_patient(scanId)"><span *ngIf="mail_sending"><i class="fa fa-spin fa-spinner"></i></span> Share With Patient <i class="fa fa-share"></i></button>
                                </div>
                            </div>
                        </div>
                        <!---------For Patient Share------------>

                        <!---------For Lab Documents------------>
                        <div class="col-md-12" *ngIf="myrole == '1' || (myrole == '3' && isCMAccess == '1') || userId == '582' || userId == '695' || userId == '584' ">
                            <div class="text-title-center pt-4"><span>Lab Documents</span></div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-12"><h3>Download/Send Lab Documents:-</h3></div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <mat-select placeholder="Lab List" [(ngModel)]="send_download_lab_list" (selectionChange)="get_appointment_type_of_lab()">
                                            <mat-option>Lab List</mat-option>
                                            <mat-option value="{{orthoUser.id}}" *ngFor="let orthoUser of ortho_user">{{orthoUser.name}}</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-4">
                                        <mat-select placeholder="Appointment Type" [(ngModel)]="send_download_appointment_type" (selectionChange)="get_scan_type_of_lab()">
                                            <mat-option>Appointment Type</mat-option>
                                            <mat-option value="{{apptType.scan_type}}"  *ngFor="let apptType of appointment_type_lab_arr">
                                                <span *ngIf="apptType.scan_type==1">New Scan</span>
                                                <span *ngIf="apptType.scan_type==2">Re-Scan</span>
                                                <span *ngIf="apptType.scan_type==3">Trust Align</span> 
                                            </mat-option>
                                        </mat-select>
                                    </div>

                                    <div class="col-sm-4">
                                        <mat-select placeholder="Select Type" [(ngModel)]="send_download_type">
                                            <mat-option>Select Type</mat-option>
                                            <mat-option value="{{scanTypeArr.plan_type}}"  *ngFor="let scanTypeArr of scan_type_lab_arr">
                                                Type {{scanTypeArr.plan_type}}
                                            </mat-option>
                                        </mat-select>
                                        <div *ngIf="type_validator_drop" class="invalid-feedback">
                                            **Type is required for Download Plan or Send Email Plan
                                        </div>
                                    </div>

                                    <div class="col-md-3 mt-2" *ngIf="send_download_type">
                                        <button type="button" [disabled]="loading" (click)="validate_type(1)" class="btn btn-success">
                                            <i class="fa fa-download" aria-hidden="true"></i> Download Plan 
                                        </button>
                                    </div>
                                    <div class="col-md-3 mt-2" *ngIf="send_download_type">
                                        <button type="button" [disabled]="loading" (click)="validate_type(2)" class="btn btn-primary">
                                            <span *ngIf="email_loading" ><i class="fa fa-spin fa-spinner"></i>&nbsp; &nbsp;</span>
                                            <i class="fa fa-envelope"  aria-hidden="true"></i> 
                                            <span *ngIf="email_loading"> Please Wait...</span> 
                                            <span *ngIf="!email_loading"> Send Plan</span>
                                        </button>
                                    </div>
                                    <div class="col-sm-12" *ngIf="email_loading && send_download_type">
                                        <br>
                                        <b>***Note::</b> <span class="text-success">&nbsp; &nbsp;Please wait email sending is in process.</span>
                                    </div>

                                </div>
                            </div>
                            <hr>
                            <div class="list-group list-group-flush list-group-hoverable docList">
                                <div class="row">
                                    <div class="col-sm-12"><h3>Filter:-</h3></div>
                                </div>
                                <div class="row mb-6 border-bottom">
                                    <div class="col-sm-4">
                                        <mat-select placeholder="Lab List" [(ngModel)]="filter_plan_lab_list">
                                            <mat-option>Lab List</mat-option>
                                            <mat-option value="{{orthoUser.id}}" *ngFor="let orthoUser of ortho_user">{{orthoUser.name}}</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-4">
                                        <mat-select placeholder="Appointment Type" [(ngModel)]="filter_plan_appt_type">
                                            <mat-option>Appointment Type</mat-option>
                                            <mat-option value="1">New Scan</mat-option>
                                            <mat-option value="3">Trust Align</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-4">
                                        <mat-select placeholder="Share Type" [(ngModel)]="filter_plan_share_type">
                                            <mat-option>Share Type</mat-option>
                                            <mat-option value="1">Type 1</mat-option>
                                            <mat-option value="2">Type 2</mat-option>
                                            <mat-option value="3">Type 3</mat-option>
                                            <mat-option value="4">Type 4</mat-option>
                                            <mat-option value="5">Type 5</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="col-sm-12 mt-2">
                                        <button type="button" [disabled]="plan_doc_loading" class="btn btn-primary mb-4" (click)="getOdsScanDocs()"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                                        <button type="button" [disabled]="plan_doc_loading" class="btn btn-primary ml-2 mb-4" (click)="resetOdsScanDocsFilter()"> <i class="fa fa-sync"></i> Reset Filters</button>
                                    </div>
                                </div>
                                
                                <div *ngIf="plan_doc_loading">
                                    <div class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
                                </div>
                                <div *ngIf="!plan_doc_loading && ods_documents.length > 0" class="lab_documents_scroll">
                                    <div *ngFor="let odsUploadDocs of ods_documents" >
                                        <div class="row showfileblock align-items-center">
                                            <div class="col text-truncate">
                                                <a href="{{s3url}}{{odsUploadDocs.filepath}}" target="_blank"
                                                    class="text-body d-block">
                                                    <span class="ft-10" *ngIf="odsUploadDocs.scan_type">
                                                        <span *ngIf="odsUploadDocs.created_by_name">
                                                            ({{odsUploadDocs.created_by_name}}) -- 
                                                        </span>
                                                        <span *ngIf="odsUploadDocs.scan_type == '1'">
                                                            (New Scan)
                                                        </span>
                                                        <span *ngIf="odsUploadDocs.scan_type == '3'">
                                                            (Trust Align)
                                                        </span>
                                                        <span *ngIf="odsUploadDocs.plan_type">
                                                        -- (Type - {{odsUploadDocs.plan_type}})
                                                        </span>
                                                    </span>
                                                    View File</a>
                                                <a  *ngIf="myrole=='1' && !odsDocsDeletingLoader"
                                                    class="delete-file float-right" mwlConfirmationPopover
                                                    [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage"
                                                    [confirmText]="confirmText" [cancelText]="cancelText"
                                                    [placement]="placement" (confirm)="removeOdsDocs(odsUploadDocs.id)"
                                                    (cancel)="cancelClicked = true" confirmButtonType="danger"
                                                    cancelButtonType="outline-secondary"
                                                    (click)="confirmClicked = false; cancelClicked = false"
                                                    [appendToBody]="true"><i class="fa fa-trash text-danger"></i></a>

                                                <i *ngIf="odsDocsDeletingLoader"
                                                    class="fa fa-spin fa-spinner float-right text-danger"></i>

                                                <span class="badge badge-success postion_span" *ngIf='odsUploadDocs.position==1'>Upper teeth
                                                    aligned initial position</span>
                                                <span class="badge badge-info postion_span" *ngIf='odsUploadDocs.position==2'>Upper teeth
                                                    aligned final position</span>
                                                <span class="badge badge-success postion_span" *ngIf='odsUploadDocs.position==3'>Upper teeth
                                                    alignment corrected initial
                                                    position</span>
                                                <span class="badge badge-primary postion_span" *ngIf='odsUploadDocs.position==4'>Upper teeth
                                                    alignment corrected final
                                                    position</span>
                                                <span class="badge badge-info postion_span" *ngIf='odsUploadDocs.position==5'>Lower teeth
                                                    aligned initial position</span>
                                                <span class="badge badge-success postion_span" *ngIf='odsUploadDocs.position==6'>Lower teeth
                                                    aligned final position</span>
                                                <span class="badge badge-primary postion_span" *ngIf='odsUploadDocs.position==7'>Lower teeth
                                                    alignment corrected initial
                                                    position</span>
                                                <span class="badge badge-info postion_span" *ngIf='odsUploadDocs.position==8'>Lower teeth
                                                    alignment corrected final
                                                    position</span>
                                                <span class="badge badge-success postion_span" *ngIf='odsUploadDocs.position==9'>Alignment
                                                    achieved initial position</span>

                                                <span class="badge badge-primary postion_span" *ngIf='odsUploadDocs.position==10'>Alignment
                                                    achieved final position</span>
                                                <span class="badge badge-info postion_span" *ngIf='odsUploadDocs.position==11'>Plan
                                                    video</span>
                                                <small
                                                    class="d-block text-muted text-truncate mt-n1">{{odsUploadDocs.filepath}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center" *ngIf="!plan_doc_loading && ods_documents.length == 0">No Data Found</div>

                            </div>
                        </div>
                        <!---------For Lab Documents------------>
                        
                    </div>
                 </div>
            </div>        
        </mat-tab>
        <mat-tab label="Production Status" *ngIf="production_status_tab">
            <div class="card col-sm-12">
                <div class="row" style="padding-left: 15px; padding-right: 15px;">
                    <div class="col-sm-7 pt-4 border-right">
                        <form [formGroup]="ScanProductionStatusForm" (submit)="addUpdateProductionStatus()">
                            <div class="form-group pt-4">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label class="form-label">Approval Received*</label>
                                        <mat-select placeholder="Select" formControlName="approval_received">
                                            <mat-option [value]="1">Yes</mat-option>
                                            <mat-option [value]="2">No</mat-option>
                                        </mat-select>
                                        <div *ngIf="production_status_submitted && p.approval_received.errors" class="invalid-feedback">
                                            <div *ngIf="p.approval_received.errors.required">Approval Received is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div class="form-group" *ngIf="ScanProductionStatusForm.controls['approval_received'].value==2">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label class="form-label">Approval Receive Reason*</label>
                                        <textarea rows="4" style="width: 80%;" formControlName="approval_received_reason"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="ScanProductionStatusForm.controls['approval_received'].value==1">

                                <div class="text-title-center pt-4"><span>SOF Documents</span></div>
                                <div class="form-group pt-4">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label class="form-label">Select SOF Filled Documents Type</label>
                                            <mat-select placeholder="Select Documents Type" formControlName="sof_filled_document_type">
                                                <mat-option [value]="7">Plan approval image</mat-option>
                                                <mat-option [value]="8">Balance payment received image</mat-option>
                                            </mat-select>
                                        </div>
                                        <div class="col-sm-6">
                                            <label class="form-label">Upload SOF Filled Document</label>
                                            <input #sofFilledUploadFile type="file" class="form-control" (change)="selectSofFIlledFile($event)" />
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-12 m-10 pr-35">
                                    <div class="list-group list-group-flush list-group-hoverable docList">
                                        <div *ngFor="let upload of allUploads">

                                            <div class="row showfileblock align-items-center" *ngIf="upload.upload_type==7||upload.upload_type==8">
                                                <div class="col text-truncate">
                                                    <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block"> View File</a> 

                                                    <a *ngIf="myrole=='1' && !fileDeletingLoader" class="delete-file float-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                                    [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile(upload.id)" (cancel)="cancelClicked = true"
                                                    confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                                    [appendToBody]="true"><i class="fa fa-trash text-danger"></i></a>

                                                    <i *ngIf="fileDeletingLoader" class="fa fa-spin fa-spinner float-right text-danger"></i>

                                                    <span class="badge badge-danger" *ngIf='upload.upload_type==7'>Plan approval image</span>
                                                    <span class="badge badge-info" *ngIf='upload.upload_type==8'>Balance payment received image</span>

                                                    
                                                    <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-title-center pt-4"><span>Production Details</span></div>
                                <div class="form-group pt-4">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <label class="form-label">Approval Received Date</label>
                                            <mat-form-field appearance="fill">
                                                <mat-label>Choose a date</mat-label>
                                                <input  matInput readonly formControlName="approval_received_date" [matDatepicker]="picker">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-8">
                                            <label class="form-label">Send To Production</label>
                                            <mat-select placeholder="Select" formControlName="send_to_production">
                                                <mat-option [value]="1">Yes</mat-option>
                                                <mat-option [value]="2">No</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div> 

                                <div class="form-group pt-4">
                                    <div class="row">
                                        <div class="col-sm-6" *ngIf="ScanProductionStatusForm.controls['send_to_production'].value==1 || ScanProductionStatusForm.controls['send_to_production'].value==2">
                                            <label class="form-label">Send To Production On (Date & Time)</label>
                                            <input type="datetime-local" formControlName="send_to_production_on" class="form-control" />
                                        </div>
                                        <div class="col-sm-6" *ngIf="ScanProductionStatusForm.controls['send_to_production'].value==1">
                                            <label class="form-label">Aligner Receive</label>
                                            <mat-select placeholder="Select" formControlName="aligner_received">
                                                <mat-option [value]="1">At Office</mat-option>
                                                <mat-option [value]="2">At Home</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div> 

                                <div *ngIf="ScanProductionStatusForm.controls['send_to_production'].value==1 && (ScanProductionStatusForm.controls['aligner_received'].value == 1 || ScanProductionStatusForm.controls['aligner_received'].value == 2)">
                                    <div class="form-group">
                                        <div class="row  pt-4">
                                            <div class="col-sm-4">
                                                <label class="form-label">Aligner Receive On (Date & Time)</label>
                                                <input type="datetime-local" formControlName="aligner_received_on" class="form-control" />
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="form-label">Upper Aligner Received</label>
                                                <input type="text" formControlName="upper_aligner_received" class="form-control" (keyup)="get_rest_aligner('upper')"/>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="form-label">Remaining Upper Aligner</label>
                                                <input type="text" formControlName="remaining_upper_aligner" class="form-control" readonly/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row pt-4">
                                            <div class="col-sm-3">
                                                <label class="form-label">Lower Aligner Received</label>
                                                <input type="text" formControlName="lower_aligner_received" class="form-control" (keyup)="get_rest_aligner('lower')"/>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="form-label">Remaining Lower Aligner</label>
                                                <input type="text" formControlName="remaining_lower_aligner" class="form-control" readonly/>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="form-label">Retainer Received</label>
                                                <mat-select placeholder="Select Retainer Received" formControlName="retainer_received">
                                                    <mat-option value="Yes">Yes</mat-option>
                                                    <mat-option value="No">No</mat-option>
                                                </mat-select>
                                            </div>
                                            <div class="col-sm-3">
                                                <label class="form-label">Retainer Dispatched</label>
                                                <mat-select placeholder="Select Retainer Dispatched" formControlName="retainer_dispatched">
                                                    <mat-option value="Yes">Yes</mat-option>
                                                    <mat-option value="No">No</mat-option>
                                                </mat-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row pt-4">
                                            <div class="col-sm-4">
                                                <label class="form-label">Tracking ID</label>
                                                <input type="text" formControlName="tracking_id" class="form-control" />
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="form-label">Aligner Dispatched Date</label>
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Choose a date</mat-label>
                                                    <input  matInput readonly formControlName="aligner_dispatched_date" [matDatepicker]="aligner_disp_picker">
                                                    <mat-datepicker-toggle matSuffix [for]="aligner_disp_picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #aligner_disp_picker></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="form-label">Aligner Delivery Date</label>
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Choose a date</mat-label>
                                                    <input  matInput readonly formControlName="aligner_delivery_date" [matDatepicker]="aligner_del_picker">
                                                    <mat-datepicker-toggle matSuffix [for]="aligner_del_picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #aligner_del_picker></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <label class="form-label">Pre treatment Complete Date</label>
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Choose a date</mat-label>
                                                    <input  matInput readonly formControlName="pre_treatment_complete_date" [matDatepicker]="pre_treatment_complete_picker">
                                                    <mat-datepicker-toggle matSuffix [for]="pre_treatment_complete_picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #pre_treatment_complete_picker></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                
                                <div *ngIf="ScanProductionStatusForm.controls['send_to_production'].value==1 && (ScanProductionStatusForm.controls['aligner_received'].value == 1 || ScanProductionStatusForm.controls['aligner_received'].value == 2)">
                                    <div class="text-title-center pt-4"><span>Clinic Visit</span></div>
                                    <div class="form-group pt-4">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label class="form-label">Clinic Visit Required</label>
                                                <mat-select placeholder="Select" formControlName="clinic_visit_required">
                                                    <mat-option [value]="1">Yes</mat-option>
                                                    <mat-option [value]="2">No</mat-option>
                                                </mat-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div *ngIf="ScanProductionStatusForm.controls['send_to_production'].value==1 && (ScanProductionStatusForm.controls['aligner_received'].value == 1 || ScanProductionStatusForm.controls['aligner_received'].value == 2)">
                                    <div class="form-group pt-4">
                                        <div class="row">
                                            <div class="col-sm-6" *ngIf="(ScanProductionStatusForm.controls['clinic_visit_required'].value == 1 || ScanProductionStatusForm.controls['clinic_visit_required'].value == 2)">
                                                <label *ngIf="ScanProductionStatusForm.controls['clinic_visit_required'].value == 1" class="form-label">Clinic visit required on (Date & Time)</label>
                                                <label *ngIf="ScanProductionStatusForm.controls['clinic_visit_required'].value == 2" class="form-label">Video Conferencing On (Date & Time)</label>
                                                <input type="datetime-local" formControlName="clinic_visit_required_on" class="form-control" />
                                            </div>
                                            <div class="col-sm-6" *ngIf="ScanProductionStatusForm.controls['clinic_visit_required'].value==1">
                                                <label class="form-label" >Select Clinic*</label>
                                                <mat-select placeholder="Select Clinic" formControlName="clinic_visit_hospital" (click)="setSearchValue('hospital')">
                                                    <input class="mySearchInput"
                                                    #hospitalSearch focused="'true'" type="text"
                                                    (keyup)="searchOnSelect($event.target.value, 'hospital')"
                                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                                    placeholder="Search"
                                                    id="hospitalSearch">
                                                    <mat-option value="">Select Hospital</mat-option>
                                                    <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                                                </mat-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group pt-4">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label class="form-label">Aligner Usages Started Date</label>
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Choose a date</mat-label>
                                                    <input  matInput readonly formControlName="aligner_usages_started_date" [matDatepicker]="aligner_usages_started_picker">
                                                    <mat-datepicker-toggle matSuffix [for]="aligner_usages_started_picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #aligner_usages_started_picker></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer pull-left">
                                <button *ngIf="myrole != '8' && myrole != '24'" [disabled]="loadingProductionStatus" type="submit" class="btn btn-primary pull-left"> <i *ngIf="loadingProductionStatus" class="fa fa-spin fa-spinner"></i> Save changes</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>        
</div>            



<div class="modal fade" id="myHistoryModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Payment History</h4>
            <button type="button" class="close" (click)="closeHistoryPopup()"></button>
        </div>
        <div class="modal-body history_modal">
            <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
              <tbody>
                  <tr *ngFor="let updatedLog of updatedLodData">
                      <td class="no-padding-bottom">
                          <div class="small_text" [innerHTML]="updatedLog.message | safe:'html'"></div>
                          <div class="small text-muted small_text_creation">
                              <i class="fas fa-clock"></i> {{updatedLog.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                          </div>
                      </td>
                  </tr>
                  <tr *ngIf="!updatedLodData.length && history_loaded">
                      <td>No history found</td>
                  </tr>
                  <tr *ngIf="history_loading">
                      <td><i class="fa fa-spin fa-spinner"></i></td>
                  </tr>
              </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" (click)="closeHistoryPopup()">Close</button>
        </div>
      </div>
    </div>
</div>